// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterGroup_wrapper__GZVgW","title":"FilterGroup_title__sRZqQ","list":"FilterGroup_list__lR6hy"};